import { QualityFeedbackType, SessionState, WebCamState,ErrorReason } from '../Enums';
import Environment from '../Environment';
import ErrorService from '../ErrorService';
import ProxyRecorder from '../ProxyRecorder';
import { Reasons } from '../Reasons/Reasons';
import SessionService from '../SessionService';
import FaceService from '../FaceService';
import Test from '../Test';
import { UiService, hide, show, disable, enable } from '../UiService';

export default class QualityCheckScreen {
    /**
     * QualityCheckScreen constructor
     * @param {UiService} uiService
     * @param {ProxyRecorder} proxyRecorder
     * @param {SessionService} sessionService
     * @param {FaceService} faceService
     * @param {Environment} environment
     * @param {any} options
     * @param {any} jsModuleSettings
     * @param {ErrorService} errorService
     * @param {Test} test
     */
    constructor(
        uiService,
        proxyRecorder,
        sessionService,
        faceService,
        environment,
        options,
        jsModuleSettings,
        errorService,
        test
    ) {
        this.uiService = uiService;
        this.proxyRecorder = proxyRecorder;
        this.sessionService = sessionService;
        this.faceService = faceService;
        this.environment = environment;
        this.errorService = errorService;
        this.test = test;

        const { qualityFeedbackType, isReviewer } = options;
        this.qualityFeedbackType = qualityFeedbackType;
        this.isReviewer = isReviewer;

        const {
            forceFullScreen,
            webcamFeedCheckTimeout,
            collectionGroupId,
            collectionGroupCompareIdList,
            isFaceUniquenessEnabled
        } = jsModuleSettings;
        this.forceFullScreen = forceFullScreen;
        this.webcamFeedCheckTimeout = webcamFeedCheckTimeout;
        this.collectionGroupId = collectionGroupId;
        this.collectionGroupCompareIdList = collectionGroupCompareIdList;
        this.isFaceUniquenessEnabled = isFaceUniquenessEnabled;
        this.displayResolve = null;

        this.showBusyMessageTimeout = null;
        this.after30BusyCamTimeout = null;
        this.camretryInterval = null;
        this.checkedFaces = new Set();
        this.checkingFaces = new Set();

        this.imageHolder = document.getElementById('image-holder');
        this.qualityCheckReady = document.getElementById('quality-check-ready');
        this.cameraBusy = document.getElementById('camera-busy');
        this.tryAgainCam = document.getElementById('try-again-cam');
        this.chooseNextCam = document.getElementById('choose-next-cam');
        this.cameraBusyTryAgain = document.getElementById('camera-busy-try-again');
        this.nextCameraDiv = document.getElementsByClassName('choose-next-cam-button');
    }

    display() {
        return new Promise(async (resolve) => {
            await this.sessionService.changeState(
                SessionState.checking_video_quality,
                Reasons.webcam_selected_or_1_webcam.id
            );

            if (this.qualityFeedbackType == QualityFeedbackType.SKIP) {
                await this.sessionService.changeState(
                    SessionState.checking_video_quality,
                    Reasons.video_quality_check_successful.id
                );

                resolve(WebCamState.readyToUse);
            }

            if (this.nextCameraDiv && this.nextCameraDiv[0] && this.environment.isMobile) {
                this.nextCameraDiv[0].style.display = 'none';
            }

            this.displayResolve = resolve;

            this.uiService.switchScreen('#quality-check-manual');

            this.qualityCheckReady.addEventListener('click', (e) => this.qualityCheckReadyClickHandler(e));
            this.chooseNextCam.addEventListener('click', (e) => this.chooseNextCamClickHandler(e));
            this.tryAgainCam.addEventListener('click', (e) => this.tryAgainClickHandler(e));

            this.cameraBusyTryAgain.addEventListener('click', (e) => {
                e.preventDefault();
                this.errorService.noWebCamActivities();
            });

            disable(this.qualityCheckReady);

            this.startCheckQualityFeed();

            const devices = await this.proxyRecorder.getAvailableDevices();
            if (devices.video && devices.video.length > 1) {
                document.getElementById('quality-check-manual').classList.add('multi-cam');
            }
            if (this.environment.browserName !== 'firefox') {
                document.getElementById('choose-next-cam-tooltip').remove();
            }
        });
    }

    async startCheckQualityFeed() {
        if (this.environment.isMobile && this.environment.isSafari) {
            hide(document.getElementById('header-content'));
            hide(this.chooseNextCam);
        }

        await this.proxyRecorder.startStreamValidation('img-container');
      
            this.proxyRecorder.on('test', (results) => this.activityValidatorFeedback(results));
         
       
        this.proxyRecorder.lat;

        const devices = await this.proxyRecorder.getCurrentDevices();
        const n = devices.video.name || 'default';
        const cameraNameElement = document.getElementById('camera-name');
        if (n.length <= 35) {
            cameraNameElement.innerText = n;
        } else {
            cameraNameElement.innerText = n.substr(0, 35) + '...';
            cameraNameElement.setAttribute('title', n);
        }
    }

    async qualityCheckReadyClickHandler(e) {
        e.preventDefault();

        const wrapperElement = document.getElementsByClassName('wrapper')[0];
        if (this.forceFullScreen === 'true' && wrapperElement.requestFullscreen && this.environment.isMobile) {
            wrapperElement.requestFullscreen();
        }

        const initPlayerPromise = this.test.initVideoPlayers();
        const stopStreamValidationPromise = this.proxyRecorder.stopStreamValidation();
        await Promise.all([initPlayerPromise, stopStreamValidationPromise]);
        this.displayResolve({ state: WebCamState.readyToUse });
    }

    async chooseNextCamClickHandler(e) {
        e.preventDefault();

        await this.proxyRecorder.stopStreamValidation();

        disable(this.qualityCheckReady);
        hide(this.tryAgainCam);

        if (this.imageHolder.classList.contains('busy')) {
            this.imageHolder.classList.remove('busy');
            this.showBusyMessageTimeout = null;
            this.after30BusyCamTimeout = null;
        }

        this.showBusyMessageTimeout = clearTimeout(this.showBusyMessageTimeout);
        this.after30BusyCamTimeout = clearTimeout(this.after30BusyCamTimeout);
        this.camretryInterval = clearInterval(this.camretryInterval);

        await this.proxyRecorder.switchToNextDevice();

        try {
            await this.proxyRecorder.askPermissions();
            // Realeyesit.Dispatcher.webcam = devices.video;
            await this.startCheckQualityFeed();
        } catch (err) {
            this.displayResolve({ state: WebCamState.denied });
        }

        hide(this.cameraBusy);
    }

    async tryAgainClickHandler(e) {
        e.preventDefault();
        const askAgain = async () => {
            disable(this.qualityCheckReady);
            hide(this.cameraBusy);
            hide(this.cameraBusyTryAgain);
            hide(this.tryAgainCam);
            this.imageHolder.classList.remove('busy');

            this.showBusyMessageTimeout = clearTimeout(this.showBusyMessageTimeout);
            this.after30BusyCamTimeout = clearTimeout(this.after30BusyCamTimeout);
            this.camretryInterval = clearInterval(this.camretryInterval);

            try {
                await this.proxyRecorder.askPermissions();

                this.startCheckQualityFeed();
            } catch (err) {
                this.displayResolve({ state:WebCamState.denied});
            }
        };

        await this.proxyRecorder.stopStreamValidation();

        await askAgain();
    }

    async activityValidatorFeedback(results) {
        if (this.environment.operatingSystemName !== 'ios') {
            this.drawEllipse(results.ok);
        }

        if (results.ok) {
            const sessionId = this.sessionService.sessionId.toString();
            const hasDuplication = await this.checkFaceDuplication(sessionId);
            if (hasDuplication) {
                console.log('Face duplication detected!');
                await this.errorService.faceDuplication();
                this.displayResolve({ state: WebCamState.failed, reason: ErrorReason.face_duplication });
                return;
            }
            if (this.checkingFaces.has(sessionId)) {
                return;
            }
            this.imageHolder.classList.remove('busy');
            this.imageHolder.classList.add('active');
            this.showBusyMessageTimeout = clearTimeout(this.showBusyMessageTimeout);
            enable(this.qualityCheckReady);
            hide(this.cameraBusyTryAgain);
            document.querySelectorAll('#camera-busy, #camera-asking').forEach(hide);

            if (this.camretryInterval) {
                clearInterval(this.camretryInterval);
            }
        } else if (results.deviceBusy) {
            if (!this.camretryInterval) {
                // todo it should be part of DC.SDK.Recorder
                this.camretryInterval = setInterval(async () => {
                    await this.proxyRecorder.askPermissions();
                }, 15000);
            }
            disable(this.qualityCheckReady);
            this.imageHolder.classList.add('busy');
            this.imageHolder.classList.remove('active');

            this.showBusyMessageTimeout =
                this.showBusyMessageTimeout ||
                setTimeout(() => {
                    show(document.getElementById('camera-busy'));

                    if (!this.environment.isMobile) {
                        show(this.tryAgainCam);
                    }
                }, 2000);

            this.after30BusyCamTimeout =
                this.after30BusyCamTimeout ||
                setTimeout(() => {
                    this.after30BusyCamTimeout = null;
                    show(this.cameraBusyTryAgain);
                }, this.webcamFeedCheckTimeout * 1000);
        } else {
            disable(this.qualityCheckReady);
            const devices = await this.proxyRecorder.getAvailableDevices();
            if (devices.video && devices.video.length > 1) {
                show(this.chooseNextCam, true);
            } else {
                show(this.tryAgainCam, true);
            }
        }
    }

    drawEllipse(isValid) {
        const ell = document.querySelector('#ellipse');
        const ctx = ell.getContext('2d');
        const video = document.getElementById('v-id');
        const w = video.clientWidth;
        let h = video.clientHeight;
        ell.width = w;
        ell.height = h;

        h = h > window.innerHeight ? window.innerHeight : h;

        ell.style.height = h + 'px';
        ell.style.width = w + 'px';

        let koef = 1;
        if (h > 360) {
            koef = h / 360.0;
        }

        let eRx = 50 * koef;
        let eRy = 70 * koef;

        if (this.environment.isMobile) {
            eRx = 80 * koef;
            eRy = 110 * koef;
        }

        ctx.clearRect(0, 0, w, h);
        ctx.strokeStyle = isValid ? '#00FF00' : '#FFFFFF';
        ctx.save();
        ctx.beginPath();
        ctx.translate(w / 2 - eRx, h / 2 - eRy - 5);
        ctx.scale(eRx, eRy);
        ctx.arc(1, 1, 1, 0, 2 * Math.PI, false);
        ctx.restore();
        ctx.stroke();
    }

    async checkFaceDuplication(sessionId) {
        if (!this.isFaceUniquenessEnabled || this.isReviewer) {
            return false;
        }
        if (this.checkingFaces.has(sessionId)) {
            console.log('This face is being checked!');
            return false;
        }
        if (this.checkedFaces.has(sessionId)) {
            console.log('This face has already been checked!');
            return false;
        }
        try {
            const img = await this.proxyRecorder.getCurrentImage();
            this.checkingFaces.add(sessionId);
            const collectionGroupCompareIdList = this.collectionGroupCompareIdList || '';
            const hasFaceDuplication = await this.faceService.searchDuplicates(
                sessionId,
                img.src,
                collectionGroupCompareIdList.split(',')
            );
            if (hasFaceDuplication) {
                return true;
            }
            await this.faceService.addTemporal(this.collectionGroupId, sessionId, img.src);
            this.checkedFaces.add(sessionId);
            this.checkingFaces.delete(sessionId);
            return false;
        } catch (error) {
            console.error('Face detection failed!', error);
        }
    }

    async addTemporal(img) {
        const sessionId = this.sessionService.sessionId.toString();
        if (!this.checkedSessions.has(sessionId)) {
            console.log('This face of session has not been checked yet!', sessionId);
            return;
        }
        if (this.addedToTemporal.has(sessionId)) {
            console.log('This face of session has already been added to temporal!', sessionId);
            return;
        }
        try {
            this.addedToTemporal.add(sessionId);
            await this.faceService.addTemporal(this.collectionGroupId, sessionId, img.src);
            this.processedSession.add(sessionId);
        } catch (error) {
            this.addedToTemporal.delete(sessionId);
            this.processedSession.delete(sessionId);
            console.error('addTemporal failed!', error);
        }
    }
}
